// Shared FlowCloser/Formac → Seaaii/Super Firm text swaps for the public legal
// + contact pages when served on a Seaaii host. Single source of truth so
// /terms and /contact stay in sync. These pages hardcode the brand/company in
// ~90 spots; rather than thread a brand variable through all of them, we swap
// the *rendered* text in place on the client (the FlowCloser markup is left
// untouched). Most-specific strings first so partial matches don't clobber
// longer ones (e.g. the full company name before the short one).
export const SEAAII_CONTACT_EMAIL = "support@seaaii.com"; // TODO: confirm real Seaaii/DPO email
export const SEAAII_LINE_ID = "@seaaii";
const FLOWCLOSER_LINE_ID = "@346nwwtm";

export const SEAAII_TEXT_SWAPS: [string, string][] = [
  // Company name (Thai / English / uppercase legal form)
  ["บริษัท ฟอร์แม็ค อินเตอร์ แอ๊คทีฟ จำกัด", "บริษัท ซุปเปอร์ เฟิร์ม จำกัด"],
  ["FORMAC INTERACTIVE COMPANY LIMITED", "SUPER FIRM CO., LTD."],
  ["Formac Interactive Co., Ltd.", "Super Firm Co., Ltd."],
  ["Formac Interactive", "Super Firm"],
  // Company registration number
  ["0105550131675", "0105565082136"],
  // Address — Thai (full form used on /terms)
  [
    "64 ซอยโชคชัย 4 ซอย 20 แยก 6 ถนนโชคชัย 4 แขวงลาดพร้าว เขตลาดพร้าว กรุงเทพมหานคร 10230",
    "281/95 ถนนวิภาวดีรังสิต แขวงสนามบิน เขตดอนเมือง กรุงเทพมหานคร 10210",
  ],
  // Address — Thai (abbreviated form used on /contact footer)
  [
    "64 ซ.โชคชัย 4 ซอย 20 แยก 6 ถ.โชคชัย 4 แขวงลาดพร้าว เขตลาดพร้าว กรุงเทพฯ 10230",
    "281/95 ถ.วิภาวดีรังสิต แขวงสนามบิน เขตดอนเมือง กรุงเทพฯ 10210",
  ],
  // Address — English
  [
    "64 Soi Chokchai 4, Soi 20, Yaek 6, Chokchai 4 Road, Lat Phrao, Bangkok 10230, Thailand",
    "281/95 Vibhavadi Rangsit Road, Sanambin, Don Mueang, Bangkok 10210, Thailand",
  ],
  // Contact email + LINE official account id
  ["flowcloser@formacinteractive.com", SEAAII_CONTACT_EMAIL],
  [FLOWCLOSER_LINE_ID, SEAAII_LINE_ID],
  // Brand name — last so it doesn't pre-empt longer matches
  ["FlowCloser", "Seaaii"],
];

// Walk every text node under `root` and apply the swaps, then repoint the
// Formac mailto links at the Seaaii address. Call inside a useEffect on a
// Seaaii host (after each render that may re-emit the original text).
export function applySeaaiiRebrand(root: HTMLElement): void {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const texts: Text[] = [];
  while (walker.nextNode()) texts.push(walker.currentNode as Text);
  for (const node of texts) {
    let v = node.nodeValue ?? "";
    for (const [from, to] of SEAAII_TEXT_SWAPS) {
      if (v.includes(from)) v = v.split(from).join(to);
    }
    if (v !== node.nodeValue) node.nodeValue = v;
  }
  root.querySelectorAll<HTMLAnchorElement>('a[href*="formacinteractive.com"]').forEach((a) => {
    a.setAttribute("href", `mailto:${SEAAII_CONTACT_EMAIL}`);
  });
  root.querySelectorAll<HTMLAnchorElement>(`a[href*="${FLOWCLOSER_LINE_ID}"]`).forEach((a) => {
    a.setAttribute("href", `https://line.me/R/ti/p/${SEAAII_LINE_ID}`);
  });
}
